import React from 'react';
import { Link } from 'react-router-dom';
import { useStrapi } from '../hooks/useStrapi';
import { getFooterSettings } from '../services/strapi';

// Fallback data when Strapi is not available
const FALLBACK_FOOTER = {
  companyName: 'Sikker SMV',
  companyDescription: 'IT-sikkerhed og compliance for danske små og mellemstore virksomheder.',
  email: 'info@sikker-smv.dk',
  cvr: 'XXXXXXXX',
  copyrightText: 'Sikker SMV. Alle rettigheder forbeholdes.',
  columns: [
    {
      title: 'Services',
      links: [
        { label: 'Complianceplatform', url: 'https://complianceplatform.dk', external: true },
        { label: 'Risikovurderinger', url: 'https://risikovurderinger.dk', external: true }
      ]
    },
    {
      title: 'Virksomhed',
      links: [
        { label: 'Om os', url: '/om-os', external: false },
        { label: 'Priser', url: '/priser', external: false },
        { label: 'Kontakt', url: '/kontakt', external: false }
      ]
    }
  ],
  socialLinks: [],
};

export default function Footer() {
  const { data: footerData } = useStrapi(getFooterSettings);

  // Strapi singleType returns { data: { attributes: { ... } } }
  // useStrapi unwraps .data, so footerData = { attributes: { ... } } or the attributes directly
  const footer = footerData?.attributes || footerData || FALLBACK_FOOTER;
  const columns = footer.columns || FALLBACK_FOOTER.columns;
  const socialLinks = (footer.socialLinks || []).filter(s => s.url);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          {/* Company info column */}
          <div>
            <h4 className="footer__title">{footer.companyName || FALLBACK_FOOTER.companyName}</h4>
            <p>{footer.companyDescription || FALLBACK_FOOTER.companyDescription}</p>
            {socialLinks.length > 0 && (
              <div className="footer__social" style={{ marginTop: '1rem' }}>
                {socialLinks.map((social, i) => (
                  <a key={i} href={social.url} target="_blank" rel="noreferrer" style={{ marginRight: '0.75rem' }}>
                    {social.platform}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Dynamic columns from Strapi */}
          {columns.map((col, i) => (
            <div key={i}>
              <h4 className="footer__title">{col.title}</h4>
              <ul className="footer__links">
                {(col.links || []).map((link, j) => (
                  <li key={j}>
                    {link.external ? (
                      <a href={link.url} target="_blank" rel="noreferrer">{link.label}</a>
                    ) : (
                      <Link to={link.url}>{link.label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact info column */}
          <div>
            <h4 className="footer__title">Kontakt</h4>
            <ul className="footer__links">
              {footer.email && <li>{footer.email}</li>}
              {footer.phone && <li>{footer.phone}</li>}
              {footer.cvr && <li>CVR: {footer.cvr}</li>}
              {footer.address && <li>{footer.address}</li>}
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} {footer.copyrightText || FALLBACK_FOOTER.copyrightText}</p>
        </div>
      </div>
    </footer>
  );
}
